import http, { url as buildUrl } from '../../http'

const API_URL = "sgsst-responsibilities"

class sgsstResponsabilitiesAPI {

  pdfUrl(id) {
    return buildUrl(`${API_URL}/${id}/pdf`)
  }

  async sign(id, payload) {
    return await http(`${API_URL}/${id}/sign`, 'POST', payload)
  }

  async save(responsabilities) {
    const response = await http(`${API_URL}/save`, 'POST', responsabilities)
    return response
  }
 
  async getAllResponsabilities() {
    const response = await http(`${API_URL}`)
    return response
  } 

  async getAllResponsabilities(id,  page) {
    const response = await http(`${API_URL}/${id}?page=${page}` )
    return response
  } 
 
  async getResponsabilities(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response
  }

  async update(id, responsabilidades) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', responsabilidades)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  // ── Acta general (tandas) ──
  async actasIndex(companyId) {
    return await http(`${API_URL}/actas/${companyId}`)
  }

  async actasStore(payload) {
    return await http(`${API_URL}/actas`, 'POST', payload)
  }

  async actasDelete(id) {
    return await http(`${API_URL}/actas/${id}`, 'DELETE')
  }

  // PDF generado + firma del acta general (modelo nuevo: la app genera, el encargado firma)
  actaPdfUrl(id) {
    return buildUrl(`${API_URL}/actas/${id}/pdf`)
  }

  async actaSign(id, payload) {
    return await http(`${API_URL}/actas/${id}/sign`, 'POST', payload)
  }

}

export default new sgsstResponsabilitiesAPI()